<template>
  <section class="xs-game-workspace">
    <table-toolbar
      :show-search="false"
      :show-refresh="false"
    >
      <template slot="left">
        <span class="reload-wrapper">
          <cache-reload reload-type="xsArgsLogin" btn-label="重载NACOS-登录参数" btn-icon="el-icon-user"/>
        </span>
        <span class="reload-wrapper">
          <cache-reload reload-type="xsArgsPay" btn-label="重载NACOS-支付参数" btn-icon="el-icon-shopping-bag-2"/>
        </span>
      </template>
    </table-toolbar>

    <logic-args
      ref="loginArgs"
      :owner-type="1"
      :args-id="appId"
      :logic-type="1"
    ></logic-args>
    <logic-args
      ref="payArgs"
      :owner-type="1"
      :args-id="appId"
      :logic-type="2"
    ></logic-args>
  </section>
</template>

<script>
import LogicArgs from '@/views/Xs/Args/LogicArgs.vue'
import CacheReload from '@/components/CacheReload/index.vue'
import TableToolbar from '@/components/TableToolbar/index.vue'

export default {
  name: 'XsArgsGame',
  components: { CacheReload, LogicArgs, TableToolbar },
  computed: {
    appId () {
      return this.$store.getters.appId
    }
  }
}
</script>

<style scoped>
.xs-game-workspace {
  padding: 16px 24px;
}

.reload-wrapper {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
}

.reload-wrapper :deep(.el-button) {
  height: 32px;
  padding: 0 16px;
  border-color: var(--border-reload) !important;
  border-radius: 8px !important;
  background-color: var(--bg-reload) !important;
  color: var(--text-reload) !important;
  font-weight: 600 !important;
}

.reload-wrapper :deep(.el-button:hover) {
  border-color: var(--border-reload-hover) !important;
  background-color: var(--bg-reload-hover) !important;
  color: var(--text-reload-hover) !important;
}

@media (max-width: 768px) {
  .xs-game-workspace {
    padding: 12px;
  }
}
</style>
